<template>
    <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2"> Nueva dirección </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field label="Nombre (alias)" dense outlined clearable :rules="validation()"
                                    type="text" v-model="form.nickname"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Dirección" dense outlined clearable type="text"
                                    hint="Campo opcional" v-model="form.address"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Telefono" dense outlined clearable type="text"
                                    hint="Campo opcional" v-model="form.phone"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Correo" dense outlined clearable type="text" hint="Campo opcional"
                                    v-model="form.email"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="Contacto" dense outlined clearable type="text"
                                    hint="Campo opcional" v-model="form.contact"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="red" block @click="closeModal()" dark :disabled="isLoading">Cancelar</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" block @click="confirmation" :loading="isLoading">Agregar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//vuex
import { mapActions } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
    data: () => ({
        isLoading: false,
        form: {
            nickname: null,
            address: null,
            phone: null,
            email: null,
            contact: null,
        }
    }),
    props: {
        value: Boolean,
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapActions("address", ["createAddress"]),
        closeModal() {
            this.show = false;
        },
        async confirmation() {
            //emit fetch table
            if (this.$refs.form.validate()) {
                try {
                    this.isLoading = true;
                    let payload = {
                        name: this.form.nickname,
                        address: this.form.address,
                        phone: this.form.phone,
                        email: this.form.email,
                        contact: this.form.contact,
                    };
                    await this.createAddress(payload);
                    this.$swal({
                        icon: "success",
                        title: `Dirección agregada`,
                        showConfirmButton: false,
                        timer: 500,
                    });
                    this.$emit("update");
                    this.closeModal()
                } catch (error) {
                    console.log(error);
                    this.$swal({
                        icon: "error",
                        title: `Algo salio mal al. Error: ${error.message}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
                this.isLoading = false;
            }
        },
        validation(name) {
            return requiredValidation(name);
        },
    },
};
</script>
